import { LargeButton } from "../_00Global/LargeButton";

export const _09Coverage = (): JSX.Element => {
  const handleContactClick = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div id="coverage" className="flex flex-col items-center justify-center relative bg-[var(--fy-blue)] scroll-mt-[100px]">
      <div className="flex flex-col items-center justify-center gap-[49px] px-[170px] py-20 relative self-stretch w-full flex-[0_0_auto]">
        <img
          className="relative w-[84.01px] h-[159.02px]"
          alt="Asset"
          src="/img/asset-46.svg"
        />

        <div className="flex flex-col w-[615px] h-[73.59px] items-center justify-center relative">
          <div className="relative self-stretch mt-[-1.21px] [font-family:var(--coverage-title-font-family)] [font-size:var(--coverage-title-font-size)] [font-weight:var(--coverage-title-font-weight)] text-[var(--fy-grey)] text-center [letter-spacing:var(--coverage-title-letter-spacing)] [line-height:var(--coverage-title-line-height)] [font-style:var(--coverage-title-font-style)]">
            Areas We Cover:
          </div>
        </div>

        <div className="flex flex-col w-[900px] h-[28.89px] items-center justify-center relative">
          <div className="relative self-stretch mt-[-1.06px] [font-family:var(--section-divider-font-family)] [font-size:var(--section-divider-font-size)] [font-weight:var(--section-divider-font-weight)] text-[var(--fy-grey)] text-center [letter-spacing:var(--section-divider-letter-spacing)] [line-height:var(--section-divider-line-height)] [font-style:var(--section-divider-font-style)]">
            ..................................................................................................................................
          </div>
        </div>

        <div className="flex flex-col w-[670px] h-[504px] items-center justify-center relative">
          <p className="relative self-stretch mt-[-1.00px] [font-family:var(--coverage-locations-font-family)] [font-size:var(--coverage-locations-font-size)] [font-weight:var(--coverage-locations-font-weight)] text-[var(--fy-grey)] text-center [letter-spacing:var(--coverage-locations-letter-spacing)] [line-height:var(--coverage-locations-line-height)] [font-style:var(--coverage-locations-font-style)]">
            Bedfordshire, Berkshire,
            <br />
            Buckinghamshire, Cambridgeshire,
            <br />
            Dorset, Essex, Gloucestershire,
            <br />
            Hampshire, Hertfordshire, Kent,
            <br />
            London, Norfolk, Northamptonshire,
            <br />
            Oxfordshire, Suffolk, Surrey, Sussex,
            <br />
            Warwickshire &amp; Wiltshire.
          </p>
        </div>

        <div className="flex flex-col w-[900px] h-[28.89px] items-center justify-center relative">
          <div className="relative self-stretch mt-[-1.06px] [font-family:var(--section-divider-font-family)] [font-size:var(--section-divider-font-size)] [font-weight:var(--section-divider-font-weight)] text-[var(--fy-grey)] text-center [letter-spacing:var(--section-divider-letter-spacing)] [line-height:var(--section-divider-line-height)] [font-style:var(--section-divider-font-style)]">
            ..................................................................................................................................
          </div>
        </div>

        <div className="flex flex-col w-[612px] h-20 items-center justify-center relative">
          <p className="relative self-stretch mt-[-1.00px] [font-family:var(--coverage-info-font-family)] [font-size:var(--coverage-info-font-size)] [font-weight:var(--coverage-info-font-weight)] text-[var(--fy-grey)] text-center [letter-spacing:var(--coverage-info-letter-spacing)] [line-height:var(--coverage-info-line-height)] [font-style:var(--coverage-info-font-style)]">
            <span className="tracking-[0.20px]">
              No Hidden Costs - All prices{" "}
            </span>

            <span className="font-bold tracking-[0.20px] underline">
              include
            </span>

            <span className="tracking-[0.20px]">
              {" "}
              the cost
              <br />
              of time, travel and accomodation.
            </span>
          </p>
        </div>

        <LargeButton text="CONTACT US" onClick={handleContactClick} />
      </div>
    </div>
  );
}; 